var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCctv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3424 4.36945L3.53513 0.0677918C3.33889 -0.0179301 3.11654 -0.0225339 2.9169 0.0549916C2.81824 0.0939357 2.72829 0.151944 2.65223 0.225675C2.57616 0.299406 2.51549 0.387402 2.47371 0.484597L0.0650342 6.08467C-0.0188416 6.27966 -0.0215542 6.49987 0.0574932 6.69685C0.136541 6.89384 0.290875 7.05147 0.486552 7.13508L6.07226 9.51991L5.07668 11.9999H1.60578V9.59992H0V16H1.60578V13.6H5.07668C5.73745 13.6 6.32276 13.2048 6.56684 12.5936L7.54797 10.1503L10.2931 11.3223C10.4879 11.4058 10.7079 11.409 10.9051 11.3314C11.1023 11.2537 11.2607 11.1015 11.3456 10.9079L13.7543 5.42226C13.8395 5.22819 13.844 5.00837 13.7668 4.81101C13.6896 4.61364 13.537 4.45485 13.3424 4.36945ZM14.3958 11.4975L12.9041 10.9039L14.5082 6.90388L16 7.49669L14.3958 11.4975Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCctv);
export default __webpack_public_path__ + "static/media/icon-cctv.d90c2c8f4d79c410787c95b93efb7209.svg";
export { ForwardRef as ReactComponent };